import { Tabs } from 'antd';
import React, { useEffect, useState } from 'react';
import { useLocation, withRouter } from 'react-router-dom';
import DocumentIconComponent from '../../../app/components/iconComponents/DocumentIconComponent';
import GalleryIconComponent from '../../../app/components/iconComponents/GalleryIconComponent';
import InfoIconComponent from '../../../app/components/iconComponents/InfoIconComponent';
import { ROUTES } from '../../../common/constants';
import history from '../../../historyData';

const ProductItemTabs = ({ match: { params: { id } = {} } = {}, children }) => {
  const [activeKey, setActiveKey] = useState();
  const location = useLocation();

  useEffect(() => {
    if (
      location?.pathname?.includes('/edit') ||
      location?.pathname?.includes('/view') ||
      location?.pathname?.includes('/add')
    ) {
      setActiveKey('INFORMATION');
    }
    if (location?.pathname?.includes('gallery')) {
      setActiveKey('GALLERY');
    }
    if (location?.pathname?.includes('document')) {
      setActiveKey('DOCUMENT');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return () => {
      if (history?.action === 'POP') {
        history?.push(history?.pathname, {
          ...location?.state
        });
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history]);

  const handleSelectTab = (key) => {
    switch (key) {
      case 'INFORMATION':
        if (location?.pathname?.includes('/add')) {
          history?.push(`${ROUTES?.PRODUCTS}/add`, {
            ...location?.state
          });
        } else if (location?.pathname?.includes('/view')) {
          history?.push(`${ROUTES?.PRODUCTS}/view/${id}`, {
            ...location?.state
          });
        } else {
          history?.push(`${ROUTES?.PRODUCTS}/edit/${id}`, {
            ...location?.state
          });
        }
        break;

      case 'GALLERY':
        if (location?.pathname?.includes('/view')) {
          history?.push(`${ROUTES?.PRODUCTS}/view${ROUTES?.GALLERY}/${id}`, {
            ...location?.state
          });
        } else {
          history?.push(`${ROUTES?.PRODUCTS}/edit${ROUTES?.GALLERY}/${id}`, {
            ...location?.state
          });
        }
        break;

      case 'DOCUMENT':
        if (location?.pathname?.includes('/view')) {
          history?.push(`${ROUTES?.PRODUCTS}/view/document/${id}`, {
            ...location?.state
          });
        } else {
          history?.push(`${ROUTES?.PRODUCTS}/edit/document/${id}`, {
            ...location?.state
          });
        }
        break;

      default:
        break;
    }
  };
  const infoTitle = (
    <div>
      <InfoIconComponent className="tab-icons" />
      <span className="card-title">Information</span>
    </div>
  );
  const galleryTitle = (
    <div>
      <GalleryIconComponent className="tab-icons" />
      <span className="card-title">Gallery</span>
    </div>
  );

  const documentTitle = (
    <div>
      <DocumentIconComponent className="tab-icons" />
      <span className="card-title">Document</span>
    </div>
  );

  const tabItems = [
    {
      label: infoTitle,
      key: 'INFORMATION',
      children
    },
    !location?.pathname?.includes('/add') && {
      label: galleryTitle,
      key: 'GALLERY',
      children
    },
    !location?.pathname?.includes('/add') && {
      label: documentTitle,
      key: 'DOCUMENT',
      children
    }
  ];

  return (
    <div className="card-container">
      <Tabs
        type="card"
        items={tabItems}
        activeKey={activeKey}
        onChange={handleSelectTab}
      />
    </div>
  );
};

export default withRouter(ProductItemTabs);
